var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/plus-small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.8,0 C7.2418278,0 7.6,0.3581722 7.6,0.8 L7.6,6 L12.8,6 C13.2418278,6 13.6,6.3581722 13.6,6.8 C13.6,7.2418278 13.2418278,7.6 12.8,7.6 L7.6,7.6 L7.6,12.8 C7.6,13.2418278 7.2418278,13.6 6.8,13.6 C6.3581722,13.6 6,13.2418278 6,12.8 L6,7.6 L0.8,7.6 C0.3581722,7.6 0,7.2418278 0,6.8 C0,6.3581722 0.3581722,6 0.8,6 L6,6 L6,0.8 C6,0.3581722 6.3581722,0 6.8,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/plus-small",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    transform: "translate(5.200000, 5.200000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#000000",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.200000, -5.200000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSmall);
export default __webpack_public_path__ + "static/media/plus-small.3d38bdee47f6eb73cd121a09a6bee70a.svg";
export { ForwardRef as ReactComponent };